import { RiskStakeImpactModel } from './RiskStakeImpactModel';
import { RiskScenarioSimulationModel } from './RiskScenarioSimulation';

export type RiskModel = {
	id: string;
	name: string;
	description: string;
	impact: number;
	likelihood: number;
	mitigation: string;
	createdAt: Date;
	updatedAt: Date;
	scenarios: RiskScenarioSimulationModel[];

	impactedStakes: RiskStakeImpactModel[];
	enabled: boolean;
};

export const defaults = {
	__typename: 'Risk',
	name: '',
	description: '',
	reference: '',
	impact: 1,
	likelihood: 1,
	riskCategoryId: '',
	isOpportunity: false,
	evaluatedAt: '',
	scenarios: [],
	taggings: [],
	impactedStakes: [],
	createdAt: new Date(),
	enabled: true
};
